module.exports = __webpack_public_path__ + "static/img/logo_nav.41f66914.png";